import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import JsonLd from './JsonLd'
import { buildSitewideGraph } from 'utils/schemaOrg'

const sitewideJsonLdQuery = graphql`
  query SitewideJsonLdQuery {
    site {
      siteMetadata {
        title
        description
        siteUrl
        image
      }
    }
    prismicGlobals {
      data {
        title
        address
        phone_number
        email
        booking_button {
          url
        }
        booking_button_text
        facebook
        instagram
      }
    }
  }
`

function SitewideJsonLd() {
  const data = useStaticQuery(sitewideJsonLdQuery)
  const siteMetadata = data.site.siteMetadata
  const globals = data.prismicGlobals?.data
  const schema = buildSitewideGraph({ siteMetadata, globals })
  return <JsonLd schema={schema} />
}

export default SitewideJsonLd
